import React, { useContext } from "react";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";
import { ClaimsActivityDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDashboardContext";
import ClaimsActivityGhostProviderScenarioTile from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityGhostProviderScenarioTile";
import ClaimsActivityProviderScenarioTile from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityProviderScenarioTile";

export const ClaimsActivityDashboardScenarioView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsActivityProviderScenarioTile
          data={claimsActivityContext.networkProviderScenarios}
          loading={claimsActivityContext.networkProviderScenariosLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
        />
      </div>
      <div className="row">
        <ClaimsActivityGhostProviderScenarioTile
          getSummaries={claimsActivityContext.getGhostScenarioWidgetData}
          loading={claimsActivityContext.ghostProviderScenarioCountiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          scenarioModel={claimsActivityContext.ghostProviderScenarioCountiesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsActivityGhostProviderScenarioTile
          getSummaries={claimsActivityContext.getGhostScenarioWidgetData}
          loading={claimsActivityContext.ghostProviderScenarioSpecialtiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          scenarioModel={claimsActivityContext.ghostProviderScenarioSpecialtiesModel}
          summaryType={PciDashboardSummaryType.Specialty}
        />
      </div>
    </React.Fragment>
  );
}
